import React from 'react';
import Icon from '../../../components/AppIcon';

const ProgressOverviewCards = ({ stats }) => {
  const cards = [
    {
      icon: 'Award',
      label: 'Total XP',
      value: stats?.totalXP?.toLocaleString() || '0',
      subtext: `Level ${stats?.currentLevel}`,
      color: 'from-accent-purple to-accent-blue',
      iconBg: 'bg-accent-purple/20',
      iconColor: 'text-accent-purple'
    },
    {
      icon: 'BookOpen',
      label: 'Plays Completed',
      value: `${stats?.playsCompleted}/${stats?.playsStarted}`,
      subtext: `${stats?.totalLinesRead} lines read`,
      color: 'from-green-500 to-emerald-600',
      iconBg: 'bg-green-500/20',
      iconColor: 'text-green-400'
    },
    {
      icon: 'Target',
      label: 'Quiz Accuracy',
      value: `${stats?.avgQuizAccuracy}%`,
      subtext: 'Average score',
      color: 'from-blue-500 to-cyan-600',
      iconBg: 'bg-blue-500/20',
      iconColor: 'text-blue-400'
    },
    {
      icon: 'Flame',
      label: 'Day Streak',
      value: stats?.consecutiveDays || '0',
      subtext: 'Keep it going!',
      color: 'from-orange-500 to-red-600',
      iconBg: 'bg-orange-500/20',
      iconColor: 'text-orange-400'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {cards?.map((card, index) => (
        <div
          key={index}
          className="bg-surface-lighter border border-border rounded-xl p-6 hover:border-accent-purple transition-all duration-300 group"
        >
          <div className="flex items-start justify-between mb-4">
            <div className={`p-3 rounded-lg ${card?.iconBg} group-hover:scale-110 transition-transform`}>
              <Icon name={card?.icon} size={24} className={card?.iconColor} />
            </div>
          </div>
          
          <div className="space-y-1">
            <p className="text-text-secondary text-sm">{card?.label}</p>
            <p className={`text-3xl font-bold bg-gradient-to-r ${card?.color} bg-clip-text text-transparent`}>
              {card?.value}
            </p>
            <p className="text-text-secondary text-xs">{card?.subtext}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProgressOverviewCards;